import React from 'react';

const clients = ['TechCorp', 'FinanceHub', 'HealthFirst', 'EduLearn', 'RetailMax', 'DataFlow', 'CloudNine', 'GreenTech'];

function MarqueeTrack() {
  return (
    <div className="marquee-track">
      {clients.map((name, i) => (
        <React.Fragment key={i}>
          <span className="marquee-item">{name}</span>
          <span className="marquee-dash">—</span>
        </React.Fragment>
      ))}
    </div>
  );
}

function Marquee() {
  return (
    <section className="marquee-section">
      <div className="marquee-inner">
        <MarqueeTrack />
        <MarqueeTrack />
      </div>
    </section>
  );
}

export default Marquee;
